import { render, staticRenderFns } from "./FourDiagnosis.vue?vue&type=template&id=3fbc0390&scoped=true&"
import script from "./FourDiagnosis.vue?vue&type=script&lang=js&"
export * from "./FourDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./FourDiagnosis.vue?vue&type=style&index=0&id=3fbc0390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc0390",
  null
  
)

export default component.exports